<div ngbDropdown
     [ngClass]="ddClasses"
     [container]="container">
  <div ngbDropdownAnchor>
    <pcs-button *ngIf="isDropdownDefault()"
                [buttonText]="buttonText"
                [buttonSize]="buttonSize"
                [buttonStyle]="buttonStyle"
                [icon]="icon"
                [buttonId]="buttonId"
                [tabindex]="tabIndex"
                [ngClass]="buttonClasses"
                [disabled]="disabled"
                ngbDropdownToggle>
    </pcs-button>

    <div *ngIf="isDropdownCustom()" ngbDropdownToggle class="dropdown-toggle-custom">
      <ng-content select="pcs-dropdown-toggle"></ng-content>
    </div>
  </div>
  <div ngbDropdownMenu [ngClass]="menuClasses" aria-labelledby="buttonId">
    <ng-content></ng-content>
  </div>
</div>
